module.exports = __webpack_public_path__ + "static/media/empty_picture.8cf2f04c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/empty_picture.jpg
// module id = 3828
// module chunks = 1